export default __webpack_public_path__ + "static/media/Michael.f1048a5a.png";